(function () {
    'use strict';

    angular
        .module('app.ggIntegration')
        .controller('GGMatchCategoryListController', GGMatchCategoryListController);

    GGMatchCategoryListController.$inject = ['$location', 'GGIntegrationService', 'NgTableParams', '$uibModal'];

    function GGMatchCategoryListController($location, GGIntegrationService, NgTableParams, $uibModal) {
        /* jshint validthis:true */
        var vm = this;
        vm.settings = globalSettings;
        activate();
        //console.log("list controller");
        function activate() {
            vm.firstLoad = true;
            vm.tableParams = new NgTableParams(
                angular.extend({ page: 1, count: 10 }, $location.search()),
                {
                    getData: function (params) {
                        if (!vm.firstLoad) {
                            $location.search(params.url());
                        }
                        vm.firstLoad = false;
                        var filterData2 = params.filter();
                        var filterData = {};
                        filterData.PageIndex = params.page(),
                            filterData.PageSize = params.count(),
                            filterData.SortProperty = Object.keys(params.sorting())[0],
                            filterData.SortType = params.sorting()[Object.keys(params.sorting())[0]];
                        var keys = Object.keys(filterData2);
                        for (var i = 0; i < keys.length; i++) {
                            filterData[keys[i]] = filterData2[keys[i]];
                        }

                        //console.log("match list"); 

                        return GGIntegrationService.gggetAllMatchCategory(filterData).then(function (data) {
                            params.total(data.FilteredCount);
                            return data.Data;
                        });

                    }
                });


            vm.fields = GGIntegrationService.gggetMatchCategoryFields();
        }


        vm.delete = function (entity) {
            if (confirm("Silmek istediğinize emin misiniz?")) {
                GGIntegrationService.ggdelMatchCategory(entity).then(function (data) {
                    vm.tableParams.reload();
                });
            }
        };

        vm.ggtransferCategory = function (entity) {
            vm.loading = true;
            console.log("category");
            GGIntegrationService.ggtransferCategory(entity).then(function (data) {
                vm.openModal(data);

                vm.loading = false;
            });
        };

        vm.transferAllCategory = function () {
            vm.loading = true;
            GGIntegrationService.ggtransferAllCategory().then(function (data) {
                vm.openModal(data);
                vm.loading = false;
            });
        };



        // Modal

        vm.modalTitle = "GittiGidiyor Error";
        vm.modalInstance = null;
        vm.openModal = function (data) {
            vm.modalInstance = $uibModal.open({
                templateUrl: 'ModalContent.html',
                controller: 'ModalController',
                controllerAs: 'vm',
                resolve: {
                    items: function () {
                        console.log(data);
                        return {
                            data: data
                        };
                    }
                }
            });
        }



    }
    angular
        .module('app.excel')
        .controller('ModalController', ModalController);

    ModalController.$inject = ['$scope', '$stateParams', '$filter', '$location', 'logger', 'ExcelService', '$uibModal', '$uibModalStack', '$uibModalInstance', 'items'];

    function ModalController($scope, $stateParams, $filter, $location, logger, ExcelService, $uibModal, $uibModalStack, $uibModalInstance, items) {

        var vm = this;
        vm.content = items;
        activate();
        function activate() {
            vm.data = vm.content.data;
        }

    }
})();